/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import React, {ReactNode} from 'react';
import {Alert, Button} from 'react-bootstrap';
import {css} from 'aphrodite/no-important';
import styles from './styles';
import Props from './Props';

class AlertWithLoginLink extends React.Component<Props> {

	static defaultProps: Props = {
		onLoginClick: () => {
			// do nothing
		},
		reasonMessage: ''
	};

	render(): ReactNode {
		const props: Readonly<Props> = this.props;

		return (
			<Alert variant="success">
				{props.reasonMessage + ' Klik '}
				<Button className={css(styles.linkButton)} type="button" variant="link" onClick={props.onLoginClick}>{'hier'}</Button>
				{' om in te loggen'}
			</Alert>
		);
	}
}

export default AlertWithLoginLink;
